import { render, staticRenderFns } from "./ProductVariantAutocomplete.vue?vue&type=template&id=25ff9e62"
import script from "./ProductVariantAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./ProductVariantAutocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports